import { CustomError } from '@core/utils';

const ROULETTE_APP_ONLY = 30403;

export const isAppOnlyRejection = (error: unknown): error is CustomError =>
  error instanceof CustomError && error.return_code === ROULETTE_APP_ONLY;
